import { http } from "@api/base";

const catalogLogsURL = "/catalog-logs/";

const get = async () => {
  const response = await http.get(catalogLogsURL);
  return response.data;
};

const catalogLogsApi = {
  get,
  searchBaseURL: catalogLogsURL,
};

export { catalogLogsApi };
